import PropTypes from "prop-types";

// @mui material components
import Collapse from "@mui/material/Collapse";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
import SoftBox from "components/SoftBox";

// Custom styles for the SidenavCollapse
import {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
  collapseRoundIconBox
} from "examples/Sidenav/styles/sidenavCollapse";

// Soft UI Dashboard React context
import { useSoftUIController } from "context";
import { useEffect, useState } from "react";
import { useLocation, NavLink } from "react-router-dom";
function SidenavCollapse({ color, icon, name, children, active, noCollapse,onChildSelect,bgcolor,nochild,line, ...rest }) {
  const [controller] = useSoftUIController();
  const { miniSidenav, transparentSidenav } = controller;
  const [open, setOpen] = useState(false);
  const [collapseName, setCollapseName] = useState('');
  const location = useLocation();
  const pathname = location.pathname;
  

  const handleToggle = () => {
    setOpen(!open);
  };

  useEffect(() => {
    setCollapseName(pathname.split('/').slice(1)[0]);
  }, [pathname]);


  return (
    <>
      <ListItem component="li" onClick={handleToggle} sx={{ cursor: 'pointer',marginBottom:0.5,marginTop:0.5 }}>
        <SoftBox {...rest} sx={(theme) => collapseItem(theme, { active, transparentSidenav, onChildSelect, bgcolor })}>
          {(bgcolor === 0 || nochild == true) && !line ?
          <ListItemIcon
            sx={(theme) => collapseIconBox(theme, { active, transparentSidenav, color })}
          >
           
              {(bgcolor === 0 || nochild == true)  ? (
              typeof icon === "string" ? (
                <Icon sx={(theme) => collapseIcon(theme, { active })}>{icon}</Icon>
              ) : (
                icon
              )
            ) : (
              open ? <ExpandLess style={{ color: "#E20074" }} /> : <ExpandMore style={{ color: "#E20074" }}/>
            )}
          </ListItemIcon>: null}


          <ListItemText
            primary={name}
            sx={(theme) => collapseText(theme, { miniSidenav, transparentSidenav, active })}
          />

    {(bgcolor === 0 || nochild == true) ? null : <ListItemIcon
            sx={(theme) => collapseRoundIconBox(theme, { active, transparentSidenav, color })}
          >
              {(bgcolor === 0 || nochild == true) ? (
              typeof icon === "string" ? (
                <Icon sx={(theme) => collapseIcon(theme, { active })}>{icon}</Icon>
              ) : (
                icon
              )
            ) : (
              open ? <ExpandLess style={{ color: "#E20074" }} /> : <ExpandMore style={{ color: "#E20074" }}/>
            )}
          </ListItemIcon>}
        </SoftBox>
      </ListItem>
      {children && (
        <Collapse style={{ borderRadius:10,backgroundColor:bgcolor == 0 ? '#fff' : '#F8ECF2',margin:'3%',borderLeft:bgcolor == 0 ? "4px solid #E20074" : null}} in={open} unmountOnExit>
             { children.map(({ type, name, icon, title, noCollapse, key, route, href,children,nochild}) => {
            return(
          <NavLink to={route} key={key}>
          <SidenavCollapse
            color={color}
            key={key}
            name={name}
            icon={icon}
            active={key ===collapseName}
            noCollapse={noCollapse}
            children={children}
            onChildSelect = {onChildSelect} 
            bgcolor={1}
            nochild={nochild}
            line={true}
          />
        </NavLink>
            )
          })}
        </Collapse>
      )}
    </>
  );
}

// Setting default values for the props of SidenavCollapse
SidenavCollapse.defaultProps = {
  color: "info",
  active: false,
  noCollapse: false,
  children: false,
  open: false,
};

// Typechecking props for the SidenavCollapse
SidenavCollapse.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
  active: PropTypes.bool,
  noCollapse: PropTypes.bool,
  open: PropTypes.bool,
};

export default SidenavCollapse;
